<main class="App">
    <div class="IERestrict">
        <div class="IERestrict-image"></div>
        <div class="IERestrict-title">Entreprise non autorisée !</div>
        <div class="IERestrict-text">Votre entreprise n'est pas autorisée à accéder à l'espace client.<br /> Merci de contacter le service client GS1 France au <strong>01 40 22 18 00</strong> ou par email <strong><a href='mailto:serviceclient@gs1fr.org'>serviceclient@gs1fr.org</a></strong>.</div>
        <br />
        <div class="IERestrict-text">
            {{ 'Unauthorized.Code_Erreur' | translate }} : {{codeErreur}}
        </div>
        <div class="IERestrict-text">Pour vous déconnecter, cliquez <a (click)="logout()">ici</a></div>
    </div>

</main>